import React, { useEffect, useState } from "react";

// Chakra imports
import {
  Avatar,
  AvatarBadge,
  Box,
  Button,
  Flex,
  Grid,
  Icon,
  Input,
  Progress,
  Text,
} from "@chakra-ui/react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
// Custom components
import Banner from "views/admin/profile/components/Banner";

// Assets
import axios from "axios";
import PlaceholderPhoto from "../../../assets/img/placeholderPhoto.png";
import { LinearProgress } from "@mui/material";
import { Search2Icon } from "@chakra-ui/icons";
import PersonIcon from "@mui/icons-material/Person";
import { useLocation } from "react-router-dom";
import moment from "moment";

export default function Matching(props) {
  const [user, setUser] = useState();
  const [localUser, setLocalUser] = useState();
  const [user1, setUser1] = useState();
  const [user2, setUser2] = useState();
  const [matchingID, setMatchingID] = useState();

  //   const [searchUser1, setSearchUser1] = useState();
  //   const [searchUser2, setSearchUser2] = useState();
  const [visibleSearchUser, setVisibleSearchUser] = useState();
  const [searchData, setSearchData] = useState([]);
  const [activeCard, setActiveCard] = useState(0);
  const [matching, setMatching] = useState();
  const [open, setOpen] = useState("");
  const [isUnlocked, setIsUnlocked] = useState(false);
  //   const [matchingCard, setMatchingCard] = useState(0);
  const [mode, setMode] = useState(0);
  const [cardMatching, setCardMatching] = useState([]);
  const [stats, setStats] = useState();
  const [level, setLevel] = useState("");
  const [error, setError] = useState("");
  moment.locale();

  useEffect(() => {
    const token = localStorage.getItem("token");
    let locUser = localStorage.getItem("user");
    setLocalUser(JSON.parse(locUser));
    if (props?.match?.params?.id && props?.match?.params?.type) {
      axios
        .get(
          `https://api.personatalenta.id/user/${props.match.params.type}/${props.match.params.id}`,
          {
            headers: {
              Authorization: `Bearer ${token ? token : ""}`,
              "Content-Type": "x-www-from-urlencode",
              "Access-Control-Allow-Origin": "http://localhost:3000",
              "Access-Control-Allow-Credentials": "true",
              "Access-Control-Allow-Headers":
                "Origin, X-Requested-With, Content-Type, Accept",
            },
          }
        )
        .then((res) => {
          setUser(res.data.user ?? res.data.colleagues);
        })
        .catch((err) => {
          if (
            err.response?.data?.message === "Unauthorized" ||
            err.response?.data === "Unauthorized"
          ) {
            // navigate('/');
          }
        });
    } else {
      if (locUser) {
        setUser(JSON.parse(locUser));
      } else {
        window.location.assign("/home");
      }
    }
  }, []);

  useEffect(() => {
    window.onscroll = function () {
      myFunction();
    };

    var navbar = document.getElementById("sticky");
    // var type = document.getElementById("type");
    var sticky = navbar.offsetTop - 150;

    function myFunction() {
      if (window.pageYOffset >= sticky) {
        navbar.classList.add("sticky");
        // type.classList.add("sticky")
      } else {
        navbar.classList.remove("sticky");
        // type.classList.remove("sticky");
      }
    }
  }, [window]);

  useEffect(() => {
    if (stats) {
      if (stats < 50) {
        setLevel("Average");
      } else if (stats < 60) {
        setLevel("Moderate");
      } else if (stats < 70) {
        setLevel("Intermediate");
      } else if (stats < 80) {
        setLevel("Leading");
      } else if (stats < 90) {
        setLevel("Advance");
      } else {
        setLevel("The BEST");
      }
    }
  }, [stats]);

  useEffect(() => {
    if (matchingID) {
      const token = localStorage.getItem("token");
      axios
        .get(`https://api.personatalenta.id/matching/detail/${matchingID}`, {
          headers: {
            Authorization: `Bearer ${token ? token : ""}`,
            "Content-Type": "x-www-from-urlencode",
          },
        })
        .then((res) => {
          if (res?.data) {
            setMatching(res?.data);
            setCardMatching(res?.data?.cards_general);
            // setMatchingCard(0);
            setStats(res?.data?.stats?.general);
            setActiveCard(1);
            // setPurchased(res.data.data)
          }
        })
        .catch((err) => {
          console.log("err: ", err);
          if (err.response.data.message) {
            setError(err.response.data.message);
          }
          if (
            err.response?.data?.message === "Unauthorized" ||
            err?.response?.data === "Unauthorized"
          ) {
            // navigate('/');
          }
        });
    }
  }, [matchingID]);

  useEffect(() => {
    if (props.match.params.id) {
      setMatchingID(props.match.params.id);
    }
  }, [props.match.params.id]);

  const onClickCard = (props) => {
    setActiveCard(props);
    // setMatchingCard(props);
    if (matching) {
      if (props === 1) {
        setCardMatching(matching.cards_general);
        setStats(matching.stats.general);
      } else if (props === 2) {
        setCardMatching(matching.cards_daily);
        setStats(matching.stats.today);
      }
    }
  };

  const onClickOpen = (text) => {
    if (isUnlocked) {
      if (text === open) {
        setOpen("");
      } else {
        setOpen(text);
      }
    } else {
      if (props?.match?.params?.id) {
        window.location.assign("/pricing#matching");
        // window.location.assign(`/dashboard/friend-list/${props.match.params.type}/${props?.match?.params?.id}/checkout/matching`)
      } else {
        window.location.assign("/pricing#matching");
        // window.location.assign(`/dashboard/profile/${user?.username}/checkout/matching`)
      }
    }
  };

  //   const onSetMatchingCard = props => {
  //     setMatchingCard(props);
  //     if (props === 0) {
  //         setCardMatching(matching.cards_general)
  //         setStats(matching.stats.general)
  //     } else if (props === 1) {
  //         setCardMatching(matching.cards_daily)
  //         setStats(matching.stats.today)
  //     }
  //   }

  return (
    <Box
      pt={{ sm: 0, base: "130px", md: "30px", xl: "30px" }}
      mt={{ sm: 10, md: 5 }}
    >
      {/* Main Fields */}
      <Grid gap={{ base: "20px", xl: "20px" }}>
        {/* <Banner
          avatar={user?.photo}
          name={user?.name}
          job={user?.occupation}
          dob={user?.birth_date}
        /> */}
        <Flex
          direction="row"
          id="sticky"
          gap={{ sm: 3, md: 5 }}
          flexWrap="wrap"
        >
          <Button
            bgColor={
              cardMatching.length === 0
                ? "gray"
                : activeCard === 1
                ? "blue.500"
                : "white"
            }
            color={
              activeCard === 1 || cardMatching.length === 0
                ? "white"
                : "blue.500"
            }
            borderWidth={1}
            borderColor="blue.500"
            fontSize={{ sm: "xs", md: "sm" }}
            fontWeight="bold"
            borderRadius="5px"
            onClick={() => onClickCard(1)}
            flex={{ sm: 1, md: "unset" }}
            disabled={cardMatching.length === 0}
            px={{ sm: "10px", md: "30px" }}
            py="5px"
          >
            General match
          </Button>
          <Button
            bgColor={
              cardMatching.length === 0
                ? "gray"
                : activeCard === 2
                ? "blue.500"
                : "white"
            }
            color={
              activeCard === 2 || cardMatching.length === 0
                ? "white"
                : "blue.500"
            }
            borderWidth={1}
            borderColor="blue.500"
            fontSize={{ sm: "xs", md: "sm" }}
            fontWeight="bold"
            borderRadius="5px"
            onClick={() => onClickCard(2)}
            disabled={cardMatching.length === 0}
            flex={{ sm: 1, md: "unset" }}
            px={{ sm: "10px", md: "30px" }}
            py="5px"
          >
            Daily match
          </Button>
        </Flex>
        {matching && activeCard !== 0 ? (
          <Flex
            flexDirection="column"
            width={{ md: "100%", lg: "75%" }}
            borderWidth={1}
            borderRadius={15}
            px={0}
            py={5}
            gap={5}
          >
            <Flex
              borderBottomWidth={1}
              flexDirection="row"
              py={2}
              gap={{ sm: 3, md: 5 }}
              minWidth="45%"
            >
              <Flex
                direction="column"
                justifyContent="center"
                alignItems="end"
                minWidth={{ sm: 30, md: 70 }}
              >
                <Avatar
                  src={matching.users[0]?.photo}
                  h={{ sm: "30px", md: "40px" }}
                  w={{ sm: "30px", md: "40px" }}
                  border="1px solid #059212"
                />
                <Text
                  fontSize={{ sm: "xs", md: "sm" }}
                  textOverflow="ellipsis"
                  whiteSpace="nowrap"
                  overflow="hidden"
                  maxWidth={"70px"}
                >
                  {matching.users[0]?.name}
                </Text>
              </Flex>
              <Flex
                direction="column"
                justifyContent="center"
                minWidth={{ sm: 30, md: 70 }}
              >
                <Avatar
                  src={matching.users[1]?.photo}
                  h={{ sm: "30px", md: "40px" }}
                  w={{ sm: "30px", md: "40px" }}
                  border="1px solid #059212"
                />
                <Text
                  fontSize={{ sm: "xs", md: "sm" }}
                  textOverflow="ellipsis"
                  whiteSpace="nowrap"
                  overflow="hidden"
                  maxWidth={"70px"}
                >
                  {matching.users[1]?.name}
                </Text>
              </Flex>
              <Flex direction="column" gap={1} justifyContent="center">
                {activeCard === 1 ? (
                  <Text fontSize={{ sm: "xs", md: "sm" }}>General</Text>
                ) : (
                  <Text fontSize={{ sm: "xs", md: "sm" }}>Daily</Text>
                )}
              </Flex>
              <Flex
                direction="column"
                width={{ sm: 50, md: 300 }}
                gap={2}
                justifyContent="center"
              >
                {activeCard === 1 ? (
                  <Box width="100%" position="relative">
                    <LinearProgress
                      sx={{
                        height: 24,
                        borderRadius: 1,
                        width: "100%",
                        position: "absolute",
                      }}
                      color={
                        matching.matching_type === 0
                          ? "warning"
                          : matching.matching_type === 1
                          ? "error"
                          : "info"
                      }
                      variant="determinate"
                      value={matching?.stats?.general}
                    />
                    <Text
                      fontSize={{ sm: "xs", md: "sm" }}
                      color="white"
                      fontWeight="bold"
                      zIndex={1}
                      position="relative"
                      textAlign="center"
                    >
                      {matching?.stats?.general}%
                    </Text>
                  </Box>
                ) : (
                  <Box width="100%" position="relative">
                    <LinearProgress
                      sx={{
                        height: 24,
                        borderRadius: 1,
                        width: "100%",
                        position: "absolute",
                      }}
                      color={
                        matching.matching_type === 0
                          ? "warning"
                          : matching.matching_type === 1
                          ? "error"
                          : "info"
                      }
                      variant="determinate"
                      value={matching?.stats?.today}
                    />
                    <Text
                      fontSize={{ sm: "xs", md: "sm" }}
                      color="white"
                      fontWeight="bold"
                      zIndex={1}
                      position="relative"
                      textAlign="center"
                    >
                      {matching?.stats?.today}%
                    </Text>
                  </Box>
                )}
              </Flex>
              {activeCard === 2 && (
                <Flex width="30%" alignItems="flex-end" justifyContent="flex-end">
                  <Text>{moment(Date.now()).format("llll")}</Text>
                </Flex>
              )}
            </Flex>
            {cardMatching.map((card, index) => (
              <Flex direction="column" key={index}>
                <Text
                  fontWeight="bold"
                  textTransform="uppercase"
                  color="#B82132"
                  fontSize={{ sm: "sm", md: "md" }}
                >
                  {card.title}
                </Text>
                <Flex
                  position="relative"
                  flexDirection="column"
                  borderWidth={0.5}
                  borderRadius={15}
                  padding={2}
                  borderColor="lightgrey"
                >
                  {card.texts.map((text) => (
                    <>
                      {text.map((item, i) => {
                        // if (item.title && item.text) {
                        return (
                          <Flex key={i} direction="column" gap={1} padding={2}>
                            <Text
                              fontWeight="bold"
                              fontSize={{ sm: "xs", md: "md" }}
                            >
                              {item.title != "null" && item.title}
                            </Text>
                            <Text
                              whiteSpace="pre-line"
                              fontSize={{ sm: "xs", md: "md" }}
                            >
                              {item.text}
                            </Text>
                            {/* <Text color="#050C9C" fontSize={{ sm: "xs", md: "md" }} fontStyle="italic" textAlign="end" mt={0} cursor="pointer" onClick={() => onClickOpen(item.text)}>{isUnlocked && item.text !== open ? "Read more" : isUnlocked && item.text === open ? "Show less" : "Deep dive"}</Text> */}
                          </Flex>
                        );
                        // }
                      })}
                    </>
                  ))}
                </Flex>
              </Flex>
            ))}
          </Flex>
        ) : (
          <Flex
            borderWidth={1}
            borderRadius={15}
            py={5}
            flexDirection="column"
            gap={5}
            width={{ sm: "100%", md: "78%" }}
          >
            {error !== "" && (
              <Flex bgColor="red" borderRadius={5} px={3} py={2}>
                <Text color="white" fontSize={{ sm: "xs", md: "sm" }}>
                  {error}
                </Text>
              </Flex>
            )}
          </Flex>
        )}
      </Grid>
    </Box>
  );
}
